import PropTypes from 'prop-types'
import React from 'react';
import { StyleSheet, View, TouchableOpacity, TextInput } from 'react-native';
import Text from 'app/components/Text'
import apiActions from 'app/utils/apiActions'

export default class Value extends React.Component {

  static propTypes = {
    value: PropTypes.object.isRequired,
    onPress: PropTypes.func,
    // onLongPress: PropTypes.func,
  }

  constructor(props) {
    super(props)
    this.state = {
      name: props.value.name
    }
  }

  render(){
    let { value, onPress } = this.props
    let { name, } = this.state
    return (
      <TouchableOpacity 
        style={styles.item} 
        onLongPress={this.handleLongPress}
        {...this.props}
      >
        <TextInput 
          style={styles.text}
          placeholderTextColor={'#ccc'}
          value={name}
          placeholder={'title'}
          onChangeText={name => this.setState({name})}
        />
      </TouchableOpacity>
    );
  }

  handleLongPress = () => {
    alert('long press')
  }
}

const styles = StyleSheet.create({  
  item: {
    // borderWidth: 1,
    borderBottomWidth: 1, 
    borderColor: '#444',
    padding: 10,
    // borderRadius: 10,
    marginRight: 10,
  },
  text: {
    color: '#eee',
  },
})